import React from 'react';

import TabPageContainer from '~components/atoms/TabPageContainer';
import EarmarkApprovalSearchAndFilterBar from './EarmarkApprovalSearchAndFilterBar';
import EarmarkApprovalTable from './EarmarkApprovalTable';
import EarmarkApprovalPaginator from './EarmarkApprovalPaginator';
import ConfirmEarmarkApprovalModal from './ConfirmEarmarkApprovalModal';

const EarmarkApproval = () => {
    return (
        <TabPageContainer>
            <EarmarkApprovalSearchAndFilterBar />

            <EarmarkApprovalTable />

            <EarmarkApprovalPaginator />

            <ConfirmEarmarkApprovalModal />
        </TabPageContainer>
    );
};

export default EarmarkApproval;
